<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('reservation_system')"
                        :isNewButton="checkPermission('reservation_store') && tabIndex == 'reservation_system'"
                        :isFilter="false"
                        :isColumns="tabIndex == 'classroom_programs' || tabIndex == 'empty_classrooms'"
                        :is-import-button="checkPermission('reservation_import')"
                        @import-button-click="importData"
                        @new-button-click="createFormShow()"
                        :other-button="{
                                show: checkPermission('reservation_bulkdelete'),
                                icon: `ri-delete-bin-line`,
                                title:$t('bulk_delete') ,
                                emit: 'bulk-delete'
                        }"
                        @bulk-delete="bulkDeleteModal"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in receivedColumns">
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>

                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('reservation_system')"
                              :isNewButton="checkPermission('reservation_store') && tabIndex == 'reservation_system'"
                              :isFilter="false"
                              :isColumns="tabIndex == 'classroom_programs' || tabIndex == 'empty_classrooms'"
                              :is-import-button="checkPermission('reservation_import')"
                              @import-button-click="importData"
                              @new-button-click="createFormShow()"
                              :other-button="{
                                show: checkPermission('reservation_bulkdelete'),
                                icon: `ri-delete-bin-line`,
                                title:$t('bulk_delete') ,
                                emit: 'bulk-delete'
                              }"
                              @bulk-delete="bulkDeleteModal"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in receivedColumns">
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>

            <b-tabs content-class="py-5 position-relative" class="line-tabs">
                <div class="tabs-bottom-line"></div>
                <b-tab :active="tabIndex=='reservation_system'"
                       @click="tabIndex='reservation_system'"
                       v-if="checkPermission('reservation_index')"
                >
                    <template #title>
                        {{ $t('reservation_system') }}
                    </template>
                    <template>
                        <reservation-system v-if="tabIndex=='reservation_system'" :rsRefresh="rsRefresh"/>
                    </template>
                </b-tab>
                <b-tab :active="tabIndex=='classroom_programs'"
                       @click="tabIndex='classroom_programs'"
                       v-if="checkPermission('reservation_classroomlist')"
                >
                    <template #title>
                        {{ $t('classroom_programs') }}
                    </template>
                    <template>
                        <classroom-schedule @send-columns="receivedColumns = $event" v-if="tabIndex=='classroom_programs'" ></classroom-schedule>
                    </template>
                </b-tab>
                <b-tab :active="tabIndex=='empty_classrooms'"
                       @click="tabIndex='empty_classrooms'"
                       v-if="checkPermission('reservation_emptyclassroom')"
                >
                    <template #title>
                        {{ $t('empty_classrooms') }}
                    </template>
                    <template>
                        <empty-classrooms @send-columns="receivedColumns = $event" v-if="tabIndex=='empty_classrooms'" @createFormShow="createFormShow($event)"></empty-classrooms>
                    </template>
                </b-tab>
                <b-tab :active="tabIndex=='conflict_informations'"
                       @click="tabIndex='conflict_informations'"
                       v-if="checkPermission('reservation_conflictreport')"
                >
                    <template #title>
                        {{ $t('conflict_informations') }}
                    </template>
                    <template>
                        <conflict-report v-if="tabIndex=='conflict_informations'"/>
                    </template>
                </b-tab>
                <b-tab :active="tabIndex=='classroom_spaces'"
                       @click="tabIndex='classroom_spaces'"
                       v-if="checkPermission('reservation_emptyclassroomreport')"
                >
                    <template #title>
                        {{ $t('classroom_spaces') }}
                    </template>
                    <template>
                        <ClassroomSpaces v-if="tabIndex=='classroom_spaces'"/>
                    </template>
                </b-tab>

                <b-tab :active="tabIndex=='classroom_matrix'"
                       @click="tabIndex='classroom_matrix'"
                       v-if="checkPermission('reservation_classroommatrix')"
                >
                    <template #title>
                        {{ $t('classroom_matrix') }}
                    </template>
                    <template>
                        <ClassroomMatrix v-if="tabIndex=='classroom_matrix'"/>
                    </template>
                </b-tab>
            </b-tabs>
            <CommonModal ref="createFormModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('reservation_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 :startData="formData"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="importFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('import').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <import-form @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
                </template>
            </CommonModal>
            <CommonModal size="md" ref="bulkDelete">
                <template v-slot:CommonModalTitle>
                    <div>{{$t('bulk_delete')}}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationProvider name="ids" v-slot="{errors}">
                            <b-form-group :label="$t('id')">
                                <multi-text v-model="form.ids"
                                            :validate-error="errors[0]"
                                            :only-number-end-enter="true"/>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <b-button type="submit"
                              variant="primary"
                              @click="bulkDelete"
                              class="btn-lg btn-block d-flex justify-content-between align-items-center">
                        {{ $t('bulk_delete').toUpper() }}
                    </b-button>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    // Components
    import ClassroomSelectbox from '@/components/interactive-fields/ClassroomSelectbox'
    import CommonModal from '@/components/elements/CommonModal'

    // Pages
    import ReservationSystem from './reservationSystem/Index'
    import CreateForm from './reservationSystem/CreateForm'
    import ClassroomSchedule from './classroomSchedule/Index'
    import EmptyClassrooms from './emptyClassrooms/Index'
    import ConflictReport from './conflictReport/Index'
    import ClassroomMatrix from './classroomMatrix/Index'
    import ImportForm from "./reservationSystem/ImportExcel"
    import ClassroomSpaces from './classroomSpaces/Index'
    import MultiText from "@/components/interactive-fields/MultiText.vue";
    import ReservationService from "@/services/ReservationService";
    export default {
        components: {
            MultiText,
            ImportForm,
            AppLayout,
            Header,
            HeaderMobile,
            ClassroomSelectbox,
            ClassroomMatrix,
            CommonModal,
            ReservationSystem,
            CreateForm,
            ClassroomSchedule,
            EmptyClassrooms,
            ConflictReport,
            ClassroomSpaces
        },
        metaInfo() {
            return {
                title: this.$t('reservation_system')
            };
        },
        data() {
            return {
                tabIndex: 'reservation_system',
                filterStatus: true,

                formLoading: false,
                formId: null,
                formData: {},
                formProcess: null,
                rsRefresh: false,
                receivedColumns: [],
                form: {},
            }
        },
        methods: {
            // Clear
            formClear() {
                this.formId = null
                this.formData = {}
                this.formProcess = null
            },

            // Create
            createFormShow(data) {
                this.formId = null
                this.formData = data
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.rsRefresh = true
                this.formClear()
            },
            importData() {
                this.formProcess = 'import'
                this.$refs.importFormModal.$refs.commonModal.show()
            },
            importFormSuccess() {
                this.formProcess = null;
                this.$refs.importFormModal.$refs.commonModal.hide()
            },
            bulkDeleteModal(){
                this.$refs.bulkDelete.$refs.commonModal.show()
            },
            bulkDelete(){
                this.$swal
                    .fire({
                        text: this.$t("are_you_sure_to_delete"),
                        showCancelButton: true,
                        confirmButtonText: this.$t("yes"),
                        cancelButtonText: this.$t("no"),
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            const {ids}=this.form
                            const array=ids.split(',');
                            const formData ={
                                ids:array
                            }
                            ReservationService.bulkDelete(formData)
                                .then((response) => {
                                    this.$toast.success(this.$t('api.' + response.data.message));
                                    this.form = {};
                                    this.$refs.bulkDelete.$refs.commonModal.hide()
                                    this.rsRefresh = !this.rsRefresh
                                })
                                .catch((error) => {
                                    this.$toast.error(this.$t("api." + error.data.message));
                                });
                        }
                    });
            },
        }
    }
</script>
